import {
  getBackend,
} from '@/backend';
import type { BackendClients } from '@/backend/contracts';
import type {
  ProjectCloudSnapshot,
  ProjectDataClient,
  ProjectDataDocumentRead,
  ProjectDataResourceKey,
  ProjectDataSubscriptionListener,
  ProjectDataSubscriptionRequest,
  ProjectMemberContext,
  ProjectWriteBaseline,
  ProjectWriteBaselineRequest,
} from '@/backend/contracts/project-data-client';
import type { ProjectScope } from './project-scope';

export type { ProjectDataResourceKey } from '@/backend/contracts/project-data-client';
export { applyProjectMemberPersonnelLinks } from './project-personnel-links';

type ProjectDataBackend = Pick<BackendClients, 'projectData'>;

function requireProjectDataClient(clients: ProjectDataBackend): ProjectDataClient {
  if (!clients.projectData) {
    throw new Error('ProjectDataClient is not configured for the active backend.');
  }
  return clients.projectData;
}

export function getProjectSnapshot(
  scope: ProjectScope,
  clients: ProjectDataBackend = getBackend(),
): Promise<ProjectCloudSnapshot> {
  return requireProjectDataClient(clients).getProject(scope);
}

export function getProjectDataDocuments(
  scope: ProjectScope,
  resourceIds: readonly ProjectDataResourceKey[],
  clients: ProjectDataBackend = getBackend(),
): Promise<ProjectDataDocumentRead[]> {
  return requireProjectDataClient(clients).getProjectDataDocuments(scope, resourceIds);
}

export function getProjectWriteBaseline(
  scope: ProjectScope,
  request: ProjectWriteBaselineRequest,
  clients: ProjectDataBackend = getBackend(),
): Promise<ProjectWriteBaseline> {
  return requireProjectDataClient(clients).getProjectWriteBaseline(scope, request);
}

export function subscribeProjectData(
  scope: ProjectScope,
  request: ProjectDataSubscriptionRequest,
  listener: ProjectDataSubscriptionListener,
  clients: ProjectDataBackend = getBackend(),
) {
  return requireProjectDataClient(clients).subscribeProject(scope, request, listener);
}

export function loadProjectMemberContext(
  scope: ProjectScope,
  userId: string,
  clients: ProjectDataBackend = getBackend(),
): Promise<ProjectMemberContext> {
  return requireProjectDataClient(clients).getProjectMemberContext(scope, userId);
}
